import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import router from './router'
import './styles.css'
import './topology.css'
import './topology-test.css'
import './group.css'
import './profiles.css'
import './secrets.css'
import './credentials.css'
import './nodes.css'
import './typography.css'
import './light-theme.css'

createApp(App).use(createPinia()).use(VueQueryPlugin).use(router).mount('#app')
